var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-number-field',{attrs:{"label":_vm.label,"name":_vm.name,"max":_vm.max,"min":_vm.min,"hide-details":_vm.hideDetails,"prefix":"%","required":""},model:{value:(_vm.value),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }